import {
	createActionsHook,
	createContainer,
	createDefaultEocWrapper,
	createHook,
	createStore,
	createSubscriber,
} from '@atlassian/eoc-rss-helpers';

import { useActions as useScheduleActions } from '../schedule-store';

import { actions } from './actions';
import { initialState } from './state';
import type { ContainerExtraProps, ContainerProps } from './types';

const store = createStore<typeof initialState, typeof actions>({
	initialState,
	actions,
});

const useStore = createHook<typeof initialState, typeof actions>(store);

const useActions = createActionsHook<typeof initialState, typeof actions>(store);

const Container = createContainer<typeof initialState, typeof actions, ContainerExtraProps>(store, {
	Wrapper: createDefaultEocWrapper({
		useSyncContainerProps: (): ContainerProps => {
			const { setRotationAction } = useScheduleActions();

			return {
				setRotationAction,
			};
		},
	}),
});

const Subscriber = createSubscriber(store);

export { Container, useStore, useActions, store, Subscriber };
